import i18n from "../i18n";
import * as Yup from "yup";
import { PERMIT_TO_WORK_CATEGORIES } from "../constants/common";

export const createPermitToWorkSchema = (
  isAttachments: {
    haveWorkPlan: number;
    haveMethodStatement: number;
    haveRiskAssessment: number;
  },
  selectedWorkCategory: string,
) => {
  return Yup.object({
    affectedService: Yup.string().required(
      i18n.language === "en"
        ? "Affected service is required."
        : "الخدمة المتأثرة مطلوبة.",
    ),

    permitStartDate: Yup.string().required(
      i18n.language === "en"
        ? "Permit start date is required."
        : "تاريخ بدء التصريح مطلوب.",
    ),
    permitEndDate: Yup.string().required(
      i18n.language === "en"
        ? "Permit end date is required."
        : "تاريخ انتهاء التصريح مطلوب.",
    ),
    workCategory: Yup.string().required(
      i18n.language === "en"
        ? "Work category is required."
        : "فئة العمل مطلوبة.",
    ),
    highRiskWorkCategory: Yup.string().when("workCategory", {
      is: PERMIT_TO_WORK_CATEGORIES.HIGH_RISK_WORKS,
      then: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "High risk work category is required."
            : "فئة العمل عالية الخطورة مطلوبة.",
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
    scopeOfWork: Yup.string().required(
      i18n.language === "en"
        ? "Scope of work is required."
        : "نطاق العمل مطلوب.",
    ),
    workType: Yup.string().required(
      i18n.language === "en" ? "Work type is required." : "نوع العمل مطلوب.",
    ),
    floorNo: Yup.string().required(
      i18n.language === "en"
        ? "Floor number is required."
        : "رقم الطابق مطلوب.",
    ),
    officeNumber: Yup.string().required(
      i18n.language === "en"
        ? "Office number is required."
        : "رقم المكتب مطلوب.",
    ),

    uploadWorkPlan: Yup.mixed().when([], {
      is: () => isAttachments.haveWorkPlan,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Work plan is required."
            : "خطة العمل مطلوبة.",
        ),
    }),

    uploadMethodStatement: Yup.mixed().when([], {
      is: () => isAttachments.haveMethodStatement,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Method statement is required."
            : "بيان الطريقة مطلوب.",
        ),
    }),

    uploadRiskAssessment: Yup.mixed().when([], {
      is: () =>
        selectedWorkCategory === PERMIT_TO_WORK_CATEGORIES.GENERAL_WORKS ||
        isAttachments.haveRiskAssessment,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Risk assessment is required."
            : "تقييم المخاطر مطلوب.",
        ),
    }),
  });
};
